import DialogModal from '@/components/DialogModal';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const CancelRecurringActionModal = ({ isOpen, onClose, onConfirm }: Props) => {
  const { t } = useTranslation('ActionRow');

  return (
    <DialogModal
      isOpen={isOpen}
      title={t('recurringCancel.title')}
      message={t('recurringCancel.message')}
      cancelText={t('recurringCancel.cancel')}
      confirmText={t('recurringCancel.confirm')}
      confirmVariant="danger"
      onCancel={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default CancelRecurringActionModal;
